module.exports = __webpack_public_path__ + "static/media/star-empty.7b8e2cbe.svg";